import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';

import Loading from '../../../components/otros/Loading';
import DataTable from 'react-data-table-component';
import AdminSidebar from '../../../components/nav/AdminSidebar';

import { getUsers } from '../../../functions/api/auth';
import { getActivosCol } from '../../../functions/api/activos';
import { getAsignaciones, createAsignaciones } from '../../../functions/api/asignacionNaves';
import { toast } from 'react-toastify';

const AsignarNave = () => {
    const [loading, setLoading] = useState(true);
    const [usuarios, setUsuarios] = useState([]);
    const [naves, setNaves] = useState([]);
    const [asignaciones, setAsignaciones] = useState([]);
    const [userSelected, setUserSelected] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);

    const { user } = useSelector((state) => state);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const usersRes = await getUsers(user.token);
                setUsuarios(usersRes.data);
                const navesRes = await getActivosCol(user.token);
                setNaves(navesRes.data);
                const asignacionesRes = await getAsignaciones(user.token);
                setAsignaciones(asignacionesRes.data);
            } catch (error) {
                console.error('Error fetching data:', error);
            } finally {
                setLoading(false);
            }
        };
        fetchData();
    }, [user.token]);

    const handleUserSelection = (e) => {
        setUserSelected(e.target.value);
        setIsModalOpen(true);
    };

    const isCheckboxChecked = (c) => {
        return asignaciones
            .filter((d) => d.userid === Number(userSelected))
            .some((item) => item.activo_id === c.id);
    };

    const handleCheckboxChange = (event, activoId) => {
        setAsignaciones((prev) => {
            const currentUserId = Number(userSelected);
            const assignmentExists = prev.some(
                (item) => item.userid === currentUserId && item.activo_id === activoId
            );

            if (event.target.checked && !assignmentExists) {
                return [...prev, { userid: currentUserId, activo_id: activoId }];
            } else if (!event.target.checked) {
                return prev.filter(
                    (item) => !(item.userid === currentUserId && item.activo_id === activoId)
                );
            }
            return prev;
        });
    };

    const saveValues = async () => {
        try {
            const userAsignaciones = asignaciones.filter((a) => a.userid === Number(userSelected));
            await createAsignaciones(user.token, userAsignaciones);
            toast.success('Naves asignadas con éxito');

            const asignacionesRes = await getAsignaciones(user.token);
            setAsignaciones(asignacionesRes.data);

            setUserSelected(null);
            setIsModalOpen(false);
        } catch (err) {
            console.error('Error saving asignaciones:', err);
            toast.error('Error al guardar las asignaciones');
        }
    };

    const columns = [
        { name: 'Nombre Usuario', selector: (row) => row.nombre },
        { name: 'Rol', selector: (row) => row.rol },
        { name: 'Asignar', selector: (row) => row.asignar },
    ];

    const data = usuarios
        .filter((d) => d.activo === true)
        .map((c) => ({
            nombre: c.nombre,
            rol: c.rol,
            asignar: (
                <button onClick={handleUserSelection} value={c.id} className='btn btn-success btn-sm'>
                    <i className='fa-solid fa-ship icon'></i> Asignar
                </button>
            ),
        }));

    return (
        <div>
            <AdminSidebar />
            {isModalOpen && (
                <div className='modern-modal-overlay'>
                    <div className='modern-modal'>
                        <div className='modern-modal-header'>
                            <h6>
                                Asignar Naves a {usuarios.find((u) => u.id === userSelected)?.nombre || ''}
                            </h6>
                        </div>
                        <div className='modern-modal-body'>
                            <div className='modern-grid'>
                                {naves.map((c) => (
                                    <div key={c.id} className='modern-checkbox-item'>
                                        <label className='modern-checkbox-label'>
                                            <input
                                                type='checkbox'
                                                checked={isCheckboxChecked(c)}
                                                onChange={(e) => handleCheckboxChange(e, c.id)}
                                                className='modern-checkbox'
                                            />
                                            <span className='modern-checkbox-custom'></span>
                                            <span className='modern-checkbox-text'>
                                                {c.nombre_activo} - {c.tipo_activo}
                                            </span>
                                        </label>
                                    </div>
                                ))}
                            </div>
                        </div>
                        <div className='modern-modal-footer'>
                            <button onClick={() => setIsModalOpen(false)} className='modern-btn modern-btn-cancel'>
                                Cancelar
                            </button>
                            <button onClick={saveValues} className='modern-btn modern-btn-save'>
                                Guardar
                            </button>
                        </div>
                    </div>
                </div>
            )}
            {loading ? (
                <div className='home'><Loading /></div>
            ) : (
                <div className='home'>
                    <div className='navCentro'>
                        <ol className='breadcrumb'>
                            <li className='breadcrumb-item'><i className='fa-solid fa-users'></i> USUARIO</li>
                            <li className='breadcrumb-item'>Asignar Nave</li>
                        </ol>
                        <div className='row navTab'>
                            <div className='col-md-12 navTabItem'>
                                <Link to='/admin/usuarios'><i className='fa-solid fa-chevron-left mr-2'></i>Atrás</Link>
                            </div>
                        </div>
                    </div>
                    <div className='row'>
                        <div className='col-md-12'>
                            <DataTable columns={columns} data={data} pagination />
                        </div>
                    </div>
                </div>
            )}
            <style>{`
                .modern-modal-overlay {
                    position: fixed;
                    top: 0;
                    left: 0;
                    right: 0;
                    bottom: 0;
                    background: rgba(0, 0, 0, 0.5);
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    z-index: 1000;
                }

                .modern-modal {
                    background: white;
                    border-radius: 12px;
                    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
                    width: 90%;
                    max-width: 900px;
                    padding: 20px;
                    animation: slideIn 0.3s ease-out;
                }

                @keyframes slideIn {
                    from {
                        transform: translateY(-50px);
                        opacity: 0;
                    }
                    to {
                        transform: translateY(0);
                        opacity: 1;
                    }
                }

                .modern-modal-header {
                    border-bottom: 1px solid #eee;
                    padding-bottom: 10px;
                    margin-bottom: 15px;
                }

                .modern-modal-header h6 {
                    margin: 0;
                    font-size: 1.2rem;
                    color: #333;
                    font-weight: 600;
                }

                .modern-modal-body {
                    max-height: 500px;
                    overflow-y: auto;
                    padding: 10px 0;
                }

                .modern-grid {
                    display: grid;
                    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
                    gap: 5px;
                    padding: 0 5px;
                }

                .modern-checkbox-item {
                    padding: 3px;
                    transition: background 0.2s;
                }

                .modern-checkbox-item:hover {
                    background: #f5f7fa;
                    border-radius: 8px;
                }

                .modern-checkbox-label {
                    display: flex;
                    align-items: center;
                    cursor: pointer;
                    position: relative;
                }

                .modern-checkbox {
                    opacity: 0;
                    position: absolute;
                    width: 0;
                    height: 0;
                }

                .modern-checkbox-custom {
                    width: 20px;
                    height: 20px;
                    border: 2px solid #6c757d;
                    border-radius: 4px;
                    margin-right: 10px;
                    position: relative;
                    transition: all 0.2s ease;
                    background: white;
                    flex-shrink: 0;
                }

                .modern-checkbox:checked + .modern-checkbox-custom {
                    background: #007bff;
                    border-color: #007bff;
                }

                .modern-checkbox-custom:after {
                    content: '';
                    position: absolute;
                    display: none;
                    left: 6px;
                    top: 2px;
                    width: 5px;
                    height: 10px;
                    border: solid white;
                    border-width: 0 2px 2px 0;
                    transform: rotate(45deg);
                }

                .modern-checkbox:checked + .modern-checkbox-custom:after {
                    display: block;
                }

                .modern-checkbox-text {
                    color: #444;
                    font-size: 1rem;
                    word-break: break-word;
                }

                .modern-modal-footer {
                    display: flex;
                    justify-content: flex-end;
                    gap: 10px;
                    padding-top: 15px;
                    border-top: 1px solid #eee;
                }

                .modern-btn {
                    padding: 8px 20px;
                    border: none;
                    border-radius: 6px;
                    font-size: 1rem;
                    cursor: pointer;
                    transition: transform 0.1s, background 0.2s;
                }

                .modern-btn:hover {
                    transform: translateY(-1px);
                }

                .modern-btn-cancel {
                    background: #f1f3f5;
                    color: #555;
                }

                .modern-btn-cancel:hover {
                    background: #e9ecef;
                }

                .modern-btn-save {
                    background: #007bff;
                    color: white;
                }

                .modern-btn-save:hover {
                    background: #0056b3;
                }

                @media (max-width: 600px) {
                    .modern-grid {
                        grid-template-columns: 1fr;
                    }
                    .modern-modal {
                        width: 95%;
                        padding: 15px;
                    }
                }
            `}</style>
        </div>
    );
};

export default AsignarNave;